import { partnerApi } from '@/stores/partnerApiClient'
import type { AdvertisementConsentResponse } from 'partner-api'

export class AdvertisementConsentService {
  static async getAdvertisementConsent(): Promise<AdvertisementConsentResponse> {
    return partnerApi().getAdvertisementConsent()
  }

  static async sendAdvertisementConsent(): Promise<void> {
    return partnerApi().addAdvertisementConsent()
  }
}
